import OrganizationApiKeys from "@/components/orgs/api-keys";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organization/api-keys")({
  component: RouteComponent,
});

function RouteComponent() {
  return <OrganizationApiKeys />;
}
